module.exports = __webpack_public_path__ + "img/text_02.f848e4f2.png";